import { render } from "./CBadge.vue?vue&type=template&id=2776bdc4"
import script from "./CBadge.vue?vue&type=script&lang=js"
export * from "./CBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__